// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0f587f","neutralColor1":"#556575","neutralColor2":"#d5dce1","neutralColor3":"#f7f9fc","neutralColor4":"#f0f2f5"};